<template>
    <v-toolbar-title v-resize="onResize" style="padding-left: 0">
        <v-img class="ml-2" contain :src="require('@/assets/tracefy-logo-text.svg')" alt="" height="30" v-if="visible" width="140"/>
    </v-toolbar-title>
</template>
<script>

export default {
  name: 'TextLogo',
  data: () => ({
    visible: true
  }),
  methods: {
    onResize () {
      this.visible = window.innerWidth > 600
    }
  }
}
</script>
<style>

    .v-text-field--box.v-text-field--single-line input {
        margin-top: 0;
    }

    a:hover {
        text-decoration: none !important;
    }

</style>
